import { HttpClient, HttpContext } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { AgentState, LOGGER_REQUEST_NAME } from '@dxp/core/types';
import { environment } from '@dxp/core/environment';

@Injectable({
    providedIn: 'root',
})
export class PresenceApiService {
    readonly #http = inject(HttpClient);

    login(): Observable<void> {
        return this.#http.post<void>(
            environment.blenderUrl + '/resource/login',
            null,
            {
                context: new HttpContext().set(
                    LOGGER_REQUEST_NAME,
                    'Presence Service (Login)',
                ),
            },
        );
    }

    logout(): Observable<void> {
        return this.#http.post<void>(
            environment.blenderUrl + '/resource/logout',
            null,
            {
                context: new HttpContext().set(
                    LOGGER_REQUEST_NAME,
                    'Presence Service (Logout)',
                ),
            },
        );
    }

    activate(): Observable<void> {
        return this.#http.post<void>(
            environment.blenderUrl + '/resource/activate',
            null,
            {
                context: new HttpContext().set(
                    LOGGER_REQUEST_NAME,
                    'Presence Service (Agent Activation)',
                ),
            },
        );
    }

    goToBreak(breakName: string): Observable<void> {
        const encoded = encodeURIComponent(breakName ?? '');

        return this.#http.post<void>(
            environment.blenderUrl +
                `/resource/moveToBreak?breakName=${encoded}`,
            null,
            {
                context: new HttpContext().set(
                    LOGGER_REQUEST_NAME,
                    'Presence Service (Agent on Break)',
                ),
            },
        );
    }

    getBreakNames(): Observable<string[]> {
        return this.#http.get<string[]>(
            environment.blenderUrl + '/resource/breaknames',
            {
                context: new HttpContext().set(
                    LOGGER_REQUEST_NAME,
                    'Presence Service (Get Break Names)',
                ),
            },
        );
    }

    changeAgentState(
        agentId: string,
        agentState: AgentState,
        breakName?: string,
    ): Observable<void> {
        let newState = null;

        switch (agentState) {
            case 'Idle':
                newState = 'activate';
                break;
            case 'PendingBreak':
                newState = 'break';
                break;
            case 'PendingLogout':
                newState = 'loggedout';
                break;
            default:
                newState = agentState.toLowerCase();
                break;
        }

        return this.#http.post<void>(
            environment.blenderUrl +
                `/manageresource/resources/${agentId}/${newState}${breakName ? `/${breakName}` : ''}`,
            null,
            {
                context: new HttpContext().set(
                    LOGGER_REQUEST_NAME,
                    'Presence Service (Change Agent State)',
                ),
            },
        );
    }
}
